/**
 * Paso a paso de instalación replicado (texto + capturas) desde la guía externa
 * (https://main.d2vpew3jmnvl49.amplifyapp.com/#/guia/instalacion-chat), pero
 * autocontenido dentro de nuestro propio modal — esa página tiene navegación
 * propia (incluye un formulario de captación de leads de evento en "inicio")
 * de la que no queremos que el cliente pueda salirse por accidente.
 *
 * Las imágenes se referencian directo desde el sitio externo (son solo
 * capturas estáticas, sin riesgo de navegación).
 */

const GUIDE_ASSET_BASE = 'https://main.d2vpew3jmnvl49.amplifyapp.com/guia';

const FLOW_EDITOR_PATH = '/service/virtual-agent/chat/flows/flows/new';

export const INSTALL_CHAT_GUIDE_STEPS = [
  {
    title: 'Instalar las aplicaciones',
    description:
      'Revisa el correo que te enviamos al activar tu producto: vas a encontrar dos enlaces de instalación, y necesitas los dos.',
    bullets: [
      'Nua Talker Social Media — conecta WhatsApp con tu HubSpot.',
      'Nua Talker Virtual Agent — le da vida a tu agente.',
    ],
    note: 'Abre cada enlace y autoriza la instalación en tu cuenta de HubSpot. ¿No encuentras el correo? Revisa spam o escríbenos y te lo reenviamos.',
  },
  {
    title: 'Conectar WhatsApp en HubSpot',
    description: 'Conecta tu número de WhatsApp a la bandeja de entrada de HubSpot.',
    substeps: [
      {
        label: 'Entra a la bandeja de entrada',
        text: 'En HubSpot: tuerca de Configuración (arriba a la derecha) → Herramientas → Bandeja de entrada.',
        image: `${GUIDE_ASSET_BASE}/chat-inst-02-bandeja.png`,
      },
      {
        label: 'Elige la vista donde quieres el canal',
        text: 'Selecciona a qué vista de la bandeja quieres asociar tu WhatsApp — define qué equipo va a ver esas conversaciones.',
      },
      {
        label: 'Conecta el canal',
        text: 'Clic en "Conectar un canal" → elige "Nua WhatsApp" → confirma con "Continuar con Nua Talker Social Media".',
        image: `${GUIDE_ASSET_BASE}/chat-inst-03-conectar-canal.png`,
      },
      {
        label: 'Autoriza con Meta',
        text: 'Inicia sesión con tu cuenta de Meta Business y elige (o conecta) el número de WhatsApp que quieres usar.',
        image: `${GUIDE_ASSET_BASE}/chat-inst-04-meta.png`,
      },
    ],
  },
  {
    title: 'Enlazar tu número con Nua App',
    description: 'Ya tienes el número conectado del lado de HubSpot; ahora hay que enlazarlo en Nua App. Te recomendamos tener las dos plataformas abiertas en pestañas separadas.',
    substeps: [
      {
        label: 'Busca tu número pendiente en Nua App',
        text: 'Menú lateral → Social Media → WhatsApp → Mis números y plantillas → sección "Números pendientes de configuración".',
        image: `${GUIDE_ASSET_BASE}/chat-inst-05-pendientes.png`,
      },
      {
        label: 'Copia el identificador desde HubSpot',
        text: 'En la misma bandeja de HubSpot, dentro de Canales, clic en "Editar" sobre tu canal de WhatsApp. Al final de la URL del navegador hay un número — cópialo.',
        image: `${GUIDE_ASSET_BASE}/chat-inst-06-url.png`,
      },
      {
        label: 'Pégalo en Nua App',
        text: 'Vuelve a "Números pendientes de configuración" y pega el identificador. Tu número queda enlazado y ya puedes recibir mensajes.',
        image: `${GUIDE_ASSET_BASE}/chat-inst-07-configurado.png`,
      },
    ],
  },
  {
    title: 'Crear tu flujo',
    description: 'Antes de asignarle un agente a tu número, arma la conversación que va a sostener: qué dice, qué pregunta y qué hace según lo que responda el cliente.',
    internalLink: { label: 'Abrir el editor de flujos', path: FLOW_EDITOR_PATH },
    note: 'Cuando tengas tu flujo listo y probado en el Playground, sigue con el paso 5.',
  },
  {
    title: 'Asignar el flujo a tu número',
    description: 'En Nua App: Social Media → Mis números y plantillas → clic en tu número → "Asignar flujo" → elige el flujo que acabas de crear.',
    image: `${GUIDE_ASSET_BASE}/chat-inst-08-asignar-flujo.png`,
    note: '¡Tu agente ya está atendiendo! Escríbele a tu propio número de WhatsApp para verlo en acción.',
  },
  {
    title: 'Crear plantillas de mensaje',
    description: 'En esa misma pantalla puedes crear plantillas personalizadas: mensajes preaprobados que te permiten escribirle tú primero a un cliente.',
    image: `${GUIDE_ASSET_BASE}/chat-inst-09-plantillas.png`,
    note: 'Las plantillas pasan por revisión de Meta antes de quedar activas — suele tomar minutos, a veces más.',
  },
];
